import React from 'react'
import Root from './Root'
import styled from 'styled-components'
import { theme } from 'src/Styles/theme'
import { StateProvider } from 'src/Reducer/StateProvider'
import { SpeedCheckProvider } from 'src/lib/ookla_speed_test/SpeedCheckContext'

const AppContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: ${theme.colors.appBackgroundColor};
  min-height: 100vh;
`

function App() {
  return (
    <AppContainer>
      <StateProvider>
        <SpeedCheckProvider>
          <Root />
        </SpeedCheckProvider>
      </StateProvider>
    </AppContainer>
  )
}

export default App
